require('../../../modules/es.array.includes');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').includes;